var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "page-container" }, [
        _c("div", { staticClass: "bg-img" }, [
          _c("img", {
            attrs: {
              src: _vm.imgSrcList.length && _vm.imgSrcList[0].img,
              alt: "",
            },
          }),
          _c("div", { staticClass: "mask", style: _vm.maskStyle }),
        ]),
        _c("div", { staticClass: "search-box" }, [
          _vm.configObj.logoConfig.isShow === 1 && _vm.logoUrl
            ? _c("img", {
                attrs: { src: _vm.logoUrl, alt: "", mode: "widthFix" },
              })
            : _vm._e(),
          _c("div", { staticClass: "box line1", style: _vm.contentStyle }, [
            _c("span", [
              _c("i", { staticClass: "el-icon-search" }),
              _c("span", [_vm._v(_vm._s(_vm.hotWord))]),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.configObj.tabShowConfig.tabVal == 0,
                expression: "configObj.tabShowConfig.tabVal == 0",
              },
            ],
            staticClass: "menus",
          },
          [
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item line1",
                  class: { on: _vm.curIndex === index },
                  style: {
                    color:
                      _vm.curIndex === index
                        ? _vm.configObj.checkColor.color[0].item
                        : _vm.textColor,
                  },
                },
                [
                  _vm._v(" " + _vm._s(item.title) + " "),
                  _c("span", { style: _vm.checkColor }),
                ]
              )
            }),
            _c("div", { staticClass: "category" }, [
              _c("span", {
                staticClass: "iconfont icon-shouye_xidingfenlei",
                style: _vm.checkColor,
              }),
            ]),
          ],
          2
        ),
        _vm.showBanner
          ? _c(
              "div",
              {
                staticClass: "banner-two",
                class: _vm.configObj.tabShowConfig.tabVal == 1 ? "mt10" : "",
              },
              [
                _c("div", { staticClass: "img-box" }, [
                  _vm.swiperType == 0
                    ? _c("div", { staticClass: "img-item item-left" }, [
                        _vm.imgSrcList.length > 1 && _vm.imgSrcList[1].img
                          ? _c("img", {
                              staticClass: "img-left",
                              style: _vm.contentStyleBanner,
                              attrs: {
                                src:
                                  _vm.imgSrcList.length > 1 &&
                                  _vm.imgSrcList[1].img,
                                alt: "",
                              },
                            })
                          : _c(
                              "div",
                              {
                                staticClass: "empty-box empty-left",
                                style: _vm.contentStyleBanner,
                              },
                              [
                                _c("span", {
                                  staticClass: "iconfont iconfont icontupian",
                                }),
                              ]
                            ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "img-item",
                      class:
                        _vm.swiperType == 0 ? "item-middle" : "item-middle-2",
                    },
                    [
                      _vm.imgSrcList.length && _vm.imgSrcList[0].img
                        ? _c("img", {
                            staticClass: "img-middle",
                            style: _vm.contentStyleBanner,
                            attrs: {
                              src:
                                _vm.imgSrcList.length && _vm.imgSrcList[0].img,
                              alt: "",
                            },
                          })
                        : _c(
                            "div",
                            {
                              staticClass: "empty-box empty-middle",
                              style: _vm.contentStyleBanner,
                            },
                            [
                              _c("span", {
                                staticClass: "iconfont iconfont icontupian",
                              }),
                            ]
                          ),
                      _c("div", [
                        _vm.docType === 0
                          ? _c(
                              "div",
                              {
                                staticClass: "dot more-dot",
                                style: _vm.dotStyle,
                              },
                              [
                                _c("div", {
                                  staticClass: "dot-item",
                                  style: {
                                    background: _vm.themeStyle
                                      ? _vm.configObj.docColor.color[0].item
                                      : _vm.themeColor,
                                  },
                                }),
                                _c("div", { staticClass: "dot-item" }),
                                _c("div", { staticClass: "dot-item" }),
                              ]
                            )
                          : _vm._e(),
                        _vm.docType === 1
                          ? _c(
                              "div",
                              {
                                staticClass: "dot more-dot line-dot",
                                style: _vm.dotStyle,
                              },
                              [
                                _c("div", {
                                  staticClass: "line_dot-item",
                                  style: {
                                    background: _vm.themeStyle
                                      ? _vm.configObj.docColor.color[0].item
                                      : _vm.themeColor,
                                  },
                                }),
                                _c("div", { staticClass: "line_dot-item" }),
                                _c("div", { staticClass: "line_dot-item" }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm.swiperType == 0
                    ? _c("div", { staticClass: "img-item item-right" }, [
                        _vm.imgSrcList.length > 2 && _vm.imgSrcList[2].img
                          ? _c("img", {
                              staticClass: "img-right",
                              style: _vm.contentStyleBanner,
                              attrs: {
                                src:
                                  _vm.imgSrcList.length > 2 &&
                                  _vm.imgSrcList[2].img,
                                alt: "",
                              },
                            })
                          : _c(
                              "div",
                              {
                                staticClass: "empty-box empty-right",
                                style: _vm.contentStyleBanner,
                              },
                              [
                                _c("span", {
                                  staticClass: "iconfont iconfont icontupian",
                                }),
                              ]
                            ),
                      ])
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
        _vm.showFeatureSection && (_vm.statsCard || _vm.sideCards.length)
          ? _c("div", { staticClass: "feature-section" }, [
              _c(
                "div",
                {
                  staticClass: "feature-layout",
                  class: { "feature-layout-only-side": !_vm.statsCard },
                },
                [
                  _vm.statsCard
                    ? _c(
                        "div",
                        {
                          staticClass: "feature-card feature-card-stats",
                          class: { "feature-card-full": !_vm.sideCards.length },
                        },
                        [
                          _c("div", { staticClass: "feature-title" }, [
                            _vm._v(_vm._s(_vm.statsCard.title)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "metric-list" },
                            _vm._l(_vm.activeMetrics, function (metric, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "metric-row" },
                                [
                                  _c("div", { staticClass: "metric-label" }, [
                                    metric.iconImage
                                      ? _c("img", {
                                          staticClass: "metric-icon-image",
                                          attrs: {
                                            src: metric.iconImage,
                                            alt: "",
                                          },
                                        })
                                      : _c("span", {
                                          staticClass: "iconfont metric-icon",
                                          class: _vm.getMetricIcon(
                                            metric,
                                            index
                                          ),
                                        }),
                                    _c("span", [_vm._v(_vm._s(metric.label))]),
                                  ]),
                                  _c("div", { staticClass: "metric-value" }, [
                                    _c("span", [_vm._v(_vm._s(metric.value))]),
                                    metric.trend !== false
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icon-xiangshang1 metric-trend",
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.sideCards.length
                    ? _c(
                        "div",
                        {
                          staticClass: "feature-side",
                          class: { "feature-side-full": !_vm.statsCard },
                        },
                        _vm._l(_vm.sideCards, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "feature-card feature-card-action",
                              class:
                                item.layout === "secondary"
                                  ? "feature-card-secondary"
                                  : "feature-card-primary",
                            },
                            [
                              _c("div", { staticClass: "feature-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "feature-title feature-action-title",
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                                item.desc
                                  ? _c("div", { staticClass: "feature-desc" }, [
                                      _vm._v(_vm._s(item.desc)),
                                    ])
                                  : _vm._e(),
                                item.buttonText
                                  ? _c(
                                      "div",
                                      { staticClass: "feature-button" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(item.buttonText)),
                                        ]),
                                        _c("span", {
                                          staticClass:
                                            "iconfont icon-ic_rightarrow feature-button-icon",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              item.layout === "secondary"
                                ? _c("div", { staticClass: "feature-badge" }, [
                                    item.badgeImage
                                      ? _c("img", {
                                          staticClass: "feature-badge-image",
                                          attrs: {
                                            src: item.badgeImage,
                                            alt: "",
                                          },
                                        })
                                      : _c("span", {
                                          staticClass:
                                            "iconfont icon-pingweifen",
                                        }),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }